<template>
  <div class="filter">
    <div class="filter__block">
      <p class="filter__title">{{ t('store.filters.category') }}</p>
      <div class="filter__block-inner">
        <ui-filter-checkbox
            v-for="category in categories"
            :key="category.node.uuid"
            :id="category.node.name + category.node.uuid"
            :modelValue="selectedCategories.includes(category.node.slug)"
            @update:modelValue="(isChecked) => updateSelectedFilters(category.node.slug, isChecked)"
        >
          {{ category.node.name }}
        </ui-filter-checkbox>
      </div>
    </div>
    <div class="filter__block">
      <p class="filter__title">{{ t('store.filters.price') }}</p>
      <div class="filter__block-price">
        <input
            type="text"
            :placeholder="t('fields.min')"
            v-model="price[0]"
            @input="filterNumberInput('min', $event)"
        >
        <input
            type="text"
            :placeholder="t('fields.max')"
            v-model="price[1]"
            @input="filterNumberInput('max', $event)"
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import UiFilterCheckbox from "@/components/ui/ui-filter-checkbox.vue";
import {useCategoryStore} from "@/stores/category.js";

const { t } = useI18n();
const route = useRoute()
const categoryStore = useCategoryStore()

const emit = defineEmits(["filterPrice", "filterCategories"]);

const categoriesFromRoute = computed(() => {
  const raw = route.query.categoriesSlugs
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') return raw.split(',').filter(Boolean)
  return []
})

const categories = computed(() => categoryStore.categories)

const price = ref(['', '']);
const selectedCategories = ref([]);

const filterNumberInput = (type, event) => {
  const value = event.target.value;
  const numericValue = value.replace(/[^0-9]/g, '');

  if (type === 'min') {
    price.value[0] = numericValue;
  } else {
    price.value[1] = numericValue;
  }
};

const updateSelectedFilters = (categorySlug, isChecked) => {
  if (isChecked) {
    if (!selectedCategories.value.includes(categorySlug)) {
      selectedCategories.value.push(categorySlug);
    }
  } else {
    selectedCategories.value = selectedCategories.value.filter(slug => slug !== categorySlug);
  }
};

watch(selectedCategories, (newSelected) => emit("filterCategories", newSelected), { deep: true });
watch(price, (newPrice) => emit("filterPrice", newPrice), { deep: true });

const initSelectedCategories = () => {
  if (categoriesFromRoute.value.length) {
    selectedCategories.value = categoriesFromRoute.value;
  }
}

watch(() => route.query.categoriesSlugs, () => {
  initSelectedCategories();
}, { immediate: true });

onMounted(async () => {
  initSelectedCategories()
});
</script>

<style lang="scss" scoped>
.filter {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #F00;
  box-shadow: 0 0 10px 1px #F00;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 25px;

  &__block {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-price {
      display: flex;
      align-items: center;
      gap: 10px;

      & input {
        width: 100%;
        border-radius: 10px;
        border: 2px solid $white;
        background-color: transparent;
        padding: 8px 13px;
        display: flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 0 40px 0 rgba(255, 255, 255, 0.46), 1px 1px 6px 0 $white;

        color: $white;
        font-size: 20px;
      }
    }
  }

  &__title {
    color: #F3F3F3;
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
  }
}
</style>